import { Link, NavLink } from "react-router-dom";

export function Nav() {
  return (
    <nav>
      <div className="container nav-inner">
        <Link to="/" className="brand" aria-label="Makers Hub homepage">
          <img src="/assets/logo-icon.png" alt="" width={36} height={36} />
          <span>Makers Hub</span>
        </Link>
        <div className="nav-links">
          <NavLink to="/workshops">Workshops</NavLink>
          <NavLink to="/over">Wie ben ik</NavLink>
          <NavLink to="/faq">FAQ</NavLink>
          <NavLink to="/contact">Contact</NavLink>
          <a href="/#inschrijven" className="btn btn-primary">
            Inschrijven
          </a>
        </div>
      </div>
    </nav>
  );
}
